import { render, staticRenderFns } from "./addOrderMan.vue?vue&type=template&id=03332d47&scoped=true"
import script from "./addOrderMan.vue?vue&type=script&lang=js"
export * from "./addOrderMan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03332d47",
  null
  
)

export default component.exports